
  import { defineComponent } from "vue";
  import { mapState } from "vuex";
  import { State } from "./store";
  import App from "./App.vue";
  import getQrCodeService from "@/services/QrCodeService";

  import scriptV1 from './apis/v1.js';
import { isDemo, isMobile } from "./utils";
  
  export default defineComponent({
    name: "PreApp",
    components: {
      App,
    },
    data() {
      return {
        iframeCode: "",
        iframeScriptCode: "",
      };
    },
    mounted() {
      const searchParams = new URLSearchParams(window.location.search);
      const qrcodeId = searchParams.get("qr") || "";
  
      if (!qrcodeId || qrcodeId.length < 4) {
        this.$store.dispatch("qrcode/displayError", {
          title: "errors.qrcodeNotFoundTitle",
          text: "errors.qrcodeNotFoundText",
        });
        return;
      }
  
      try {
        this.$store.dispatch("qrcode/load", qrcodeId);
        if (!isDemo() && isMobile() ) {
            this.$store.dispatch("qrcode/logScan", qrcodeId);
        }
      } catch (e) {
        console.error(e);
      }
    },
    computed: {
      ...mapState({
        project: (state: State) => state.qrcode,
      }),
    },
    watch: {
      project: {
        immediate: true,
        deep: true,
        handler() {
          if (!this.project || !this.project.qrcodeObject) {
            return;
          }
          const QR = this.project.qrcodeObject;
          if (QR.customHTML){
            if(QR.customCode) {
              this.iframeCode = QR.customCode;
              switch (QR.customAPIVersion) {
                default:
                case "No API":
                  this.iframeScriptCode = "";
                  break;
                case "v1":
                  this.iframeScriptCode = this.buildScriptV1(QR,scriptV1);
                  break;
              }
            }
            if (QR.customTitle) {
                document.title = QR.customTitle;
            }

            if (QR.customFavicon) {
                const link: HTMLLinkElement =
                    document.querySelector("link[rel*='icon']") || document.createElement("link");
                link.type = "image/x-icon";
                link.rel = "shortcut icon";
                link.href = QR.customFavicon;
                document.getElementsByTagName("head")[0].appendChild(link);
            }
          } 
          
        },
      },
    },
    methods:{
        getEnvPath(){
            return "var STQR_API_ENV = "+ JSON.stringify({
                serverRoot : process.env.VUE_APP_API_ROOT,
                bearMedia : process.env.VUE_APP_BEAR_API_MEDIA,
                mediaRoot : process.env.VUE_APP_MEDIA_ROOT,
            })
        },
        buildScriptV1(QR, script:string){
            const obj = {
              QRid: QR.qrcodeId,
              id: QR._id,
              experiences : QR.experiences,
              projectReported: QR.projectReported || false,
              projectBanned: QR.projectBanned || false,
              status: QR.status || "BLANK", 
              //videoPath: "",
            }
            //if(QR.status === "USED" && QR.experiences.length){
            //  obj.videoPath = getQrCodeService().getFullVideoPath(QR.experiences[0].assets[0].data);
            //}
            return this.getEnvPath()+ script+"("+JSON.stringify(obj)+")";
        }
    }
  });
  